import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setAuthModal } from '@state/auth/auth.actions';

@Component({
  selector: 'app-auth-welcome-user',
  templateUrl: './welcome-user.component.html',
  styleUrls: ['./welcome-user.component.scss'],
})
export class WelcomeUserComponent {
  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  closeAuthModal(): void {
    this.store.dispatch(setAuthModal({ authModal: undefined }));
    this.router.navigate(['/']);
  }
}
